import { render, staticRenderFns } from "./pwa_color.vue?vue&type=template&id=107db75c&scoped=true&"
import script from "./pwa_color.vue?vue&type=script&lang=js&"
export * from "./pwa_color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107db75c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('107db75c')) {
      api.createRecord('107db75c', component.options)
    } else {
      api.reload('107db75c', component.options)
    }
    module.hot.accept("./pwa_color.vue?vue&type=template&id=107db75c&scoped=true&", function () {
      api.rerender('107db75c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/pwa/settings/tabs/pwa_color.vue"
export default component.exports